import { Card } from "@/components/ui/card";
import { Superscript } from "@hypercard/web-components";

type Props = {
  headerText: string;
  children: React.ReactNode;
};

export const ChartCard = ({ headerText, children }: Props) => {
  return (
    <Card className="flex flex-col p-6">
      {headerText && (
        <Superscript size="md" className="text-[#676767]">
          {headerText}
        </Superscript>
      )}
      {children}
    </Card>
  );
};
